import React from 'react';
import {DataItem, RadioInput} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import _ from 'lodash';
import {IDeveloperField} from 'dromo-uploader-react';

interface DisplayProps {
  value: string;
}

interface Props {
  valueKey: string;
}

export const phoneTypeValues = [
  {value: 'home', title: 'Home', label: 'Home'},
  {value: 'work', title: 'Work', label: 'Work'},
  {value: 'mobile', title: 'Mobile', label: 'Mobile'},
];

export const Import = (
  key: string = 'use',
  prefix?: string,
): IDeveloperField => ({
  label:
    (prefix ? prefix + ' ' : '') +
    `Phone Type (${phoneTypeValues.map(value => value.label).join(', ')})`,
  key,
  type: 'select',
  selectOptions: phoneTypeValues,
});

const resolveDisplayValue = (value: string) => {
  return _.capitalize(value);
};

const PhoneNumberTypeDisplay = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Phone Type</Text>
      <Text style={[Typography.P3]}>{resolveDisplayValue(value)}</Text>
    </DataItem>
  );
};

const PhoneNumberTypeInput = ({valueKey}: Props) => {
  return (
    <RadioInput
      valueKey={(valueKey ? valueKey + '.' : '') + 'use'}
      name={'Phone Type'}
      required={false}
      buttons={phoneTypeValues}
    />
  );
};

export const validation = () =>
  Yup.string().required('Phone number type is required');

export const Display = PhoneNumberTypeDisplay;
export const Input = PhoneNumberTypeInput;
export const Value = resolveDisplayValue;

export default PhoneNumberTypeInput;
